<template>
	<div class="contentPage">
		<main-table-all-back
				v-if="customerInvoiceItemsLimit"
				:flag="flag"
				page-title="Customer Invoice Items"
				:headers="headers"
				:settings="getSettings"
				:filtersList="customerInvoiceItemsFilters"
				:list="customerInvoiceItemsList"
				:defaultOrder="customerInvoiceItemsOrder"
				:defaultSort="customerInvoiceItemsSort"

				:totals="customerInvoiceItemsTotals"
				:total-pages="customerInvoiceItemsTotal"
				:limit-pages="customerInvoiceItemsLimit"
				:pages="[ 15, 50, 100, 200, 500, 'All' ]"
				:uniqId="uniqId"
				@updateSettings="onSettingsOpen"
				@updateEvent="onEvent"
				@updateClickButton="onClickButton"
				@updateList="onList"
				@updateRefreshFilters="onUpdateFilters(defaultFilter)"
				@updateExport="onExport"
				:isExport="isExport()"
				is-export-permissions
				:is-create="false"
				:is-settings="false"
		></main-table-all-back>
		<table-settings
				v-if="isTableSettingsDrawer"
				@updateSettingsSave="onSettingsSave('lost-payment')"
				@updateSettingsCancel="onSettingsCancel"
				@updateSettingsClose="onSettingsClose"
				@updateSettingsAll="onSettingsAll"
				:settings="getSettings"
		></table-settings>

		<dialog-remove
				v-if="isDialogRemove"
				:titleRemove="titleRemove"
				:textRemove="textRemove"
				@updateRemove="onRemove"
				@updateCloseRemove="onCloseRemove"
		></dialog-remove>

		<preload v-if="isPreloader"></preload>

	</div>
</template>

<script>
import MainTableAllBack from "@/shared/MainTableAllBack/MainTableAllBack.vue";
import settingsMixins from "@/mixins/settingsMixins";
import removeMixins from "@/mixins/removeMixins";
import { mapActions, mapGetters } from "vuex";
import DialogRemove from "@/shared/DialogRemove/DialogRemove.vue";
import Preload from "@/shared/Preload/Preload.vue";
import { TEXT, TITLE } from "@/pages/Settings/UserAccountSettings/constants";
import { PAGE, PERMISSIONS } from "@/constants/constants";
import { getPermissionsMod } from "@/helper/getPermissionsMod";

export default {
	name: "CustomerInvoiceItems",
	mixins: [ settingsMixins, removeMixins ],
	components: {
		Preload,
		DialogRemove,
		MainTableAllBack,
	},
	computed: mapGetters([
		"customerInvoiceItemsList",
		"customerInvoiceItemsFilters",
		"customerInvoiceItemsTotals",
		"permissions",
		"permissionsDefault",
		"customerInvoiceItemsOrder",
		"customerInvoiceItemsLimit",
		"customerInvoiceItemsSort",
		"customerInvoiceItemsTotal",
		"previewLink",
	]),
	data: () => ({
		flag: PAGE.CUSTOMER_INVOICE_ITEMS,
		isCustomerInvoiceItemsForm: false,
		driverId: null,
		defaultFilter: null,
		activeTableFilters: null,
		isPreloader: false,
		activeItem: null,
		isDialogRemove: false,
		titleRemove: null,
		textRemove: null,
	}),
	methods: {
		...mapActions([
			'getCustomerInvoiceItems',
			'getCustomerInvoiceItemsFilters',
			'actionPreloader',
			'onExportLink',
			'deleteCustomerInvoiceItems'
		]),
		onCloseDialog(isRefresh) {
			this.isCustomerInvoiceItemsForm = false;
			if (isRefresh) {
				this.onUpdateFilters(this.defaultFilter);
			}
		},

		async onEvent(flag) {
			if (flag === 'create') {
				this.isCustomerInvoiceItemsForm = true;
				this.driverId = null;
			}
		},
		async onUpdateFilters(filters, isWithoutFilters) {
			await this.getCustomerInvoiceItems(filters);
			if (!isWithoutFilters) await this.getCustomerInvoiceItemsFilters(filters);
		},
		async onList(values) {
			const { value, flag } = values;
			// сохраняем выбранные фильтры отдельно
			this.activeTableFilters = value;

			switch (flag) {
				case "sorting":
					await this.getCustomerInvoiceItems(value);
					break;
				case "page":
					await this.onUpdateFilters(value, true);
					break;
				default:
					await this.onUpdateFilters(value);
			}
		},
		async onExport(values) {
			await this.onExportLink({ values, requestKey: 'payments' });
		},
		isExport() {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.ACCOUNTING, PERMISSIONS.CUSTOMER_INVOICE_ITEMS, PERMISSIONS.EXPORT ];
			const returnMod = getPermissionsMod({ list, path });
			console.info('%c [  returnMod  ] ', 'color:#bada55', returnMod );
			return false;
		},
		async onClickButton({ key, item }) {
			this.activeItem = item;

			if ( key === 'delete' ) {
				const title = TITLE.CUSTOMER_INVOICE_ITEMS;
				const text = TEXT.CUSTOMER_INVOICE_ITEMS;
				this.onRemoveDialog({ title, text });
			}
		},

		async onRemove() {
			const { id } = this.activeItem;
			await this.deleteCustomerInvoiceItems(id);
			this.onCloseRemove();
		},
		onRemoveDialog(args) {
			const { title, text } = args;
			this.titleRemove = title;
			this.textRemove = text;
			this.isDialogRemove = true;
		},
		onCloseRemove() {
			this.isDialogRemove = false;
		},

	},
	async mounted() {
		await this.onUpdateFilters();
	}
};
</script>

<style scoped lang="scss"></style>
